export default ({ theme, INPUT_BASE }) => ({
  MuiInputBase: {
    root: { color: theme.palette.secondary.darkest },
    input: { color: theme.palette.secondary.darkest }
  }
})
